import { AlternativePaymentMethod, PaymentType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const paymentTypeTextKeyMap: Record<PaymentType, Mews.TextKey> = {
    [PaymentType.Cash]: TextKey.CashPayment,
    [PaymentType.CreditCard]: TextKey.CreditCardPayment,
    [PaymentType.External]: TextKey.ExternalPayment,
    [PaymentType.Invoice]: TextKey.InvoicePayment,
    [PaymentType.Alternative]: TextKey.AlternativePayment,
    [PaymentType.Ghost]: TextKey.GhostPayment,
    [PaymentType.TaxDeducted]: TextKey.TaxDeductedPayment,
};

export const refundTypeTextKeyMap: Record<PaymentType, Mews.TextKey> = {
    [PaymentType.Cash]: TextKey.CashRefund,
    [PaymentType.CreditCard]: TextKey.CardPaymentRefund,
    [PaymentType.External]: TextKey.ExternalRefund,
    [PaymentType.Invoice]: TextKey.InvoiceRefund,
    [PaymentType.Alternative]: TextKey.AlternativeRefund,
    [PaymentType.Ghost]: TextKey.GhostRefund,
    [PaymentType.TaxDeducted]: TextKey.TaxDeductedRefund,
};

export const alternativePaymentMethodTextKeyMap: Record<AlternativePaymentMethod, Mews.TextKey> = {
    [AlternativePaymentMethod.Ideal]: TextKey.IDeal,
    [AlternativePaymentMethod.ApplePay]: TextKey.ApplePay,
    [AlternativePaymentMethod.GooglePay]: TextKey.GooglePay,
    [AlternativePaymentMethod.SepaDirectDebit]: TextKey.DirectDebit,
};

export const alternativePaymentMethodRefundTextKeyMap: Record<AlternativePaymentMethod, Mews.TextKey> = {
    [AlternativePaymentMethod.Ideal]: TextKey.IdealRefund,
    [AlternativePaymentMethod.ApplePay]: TextKey.ApplePayRefund,
    [AlternativePaymentMethod.GooglePay]: TextKey.GooglePayRefund,
    [AlternativePaymentMethod.SepaDirectDebit]: TextKey.DirectDebitRefund,
};
